export default __webpack_public_path__ + "static/media/dont-miss.4f08713e.webp";